<template>
  <nx-bform-group :label="name" v-bind="$attrs">
    <nx-bform-select
      :name="name"
      :rules="{ required }"
      :value="$attrs.value"
      @input="$listeners.input"
      :options="loginAsOptions"
    />
  </nx-bform-group>
</template>

<script>
import { SystemSettingApi } from "nx-libs";
import FormGroupMixin from "../form-group.mixin";
import { groupBy } from "lodash";

const roleMapping = {
  ESHProfessionalMember: "Professional"
};

export default {
  mixins: [FormGroupMixin],
  data() {
    return {
      loginAsOptions: []
    };
  },
  computed: {
    name() {
      return this.label || this.$t("loginAs");
    }
  },
  async created() {
    const { data: settings } = await SystemSettingApi.getPublicSystemSetting();

    const groups = groupBy(
      settings.MemberRegistrationPolicy.profiles.filter(
        (profile) => profile.objectClass !== null
      ),
      (profile) => profile.objectClass
    );

    this.loginAsOptions = Object.keys(groups)
      .map((e) => ({
        label: roleMapping[e] || e,
        options: groups[e].map((e) => ({
          value: e.defaultGroups[0],
          text: e.description
        }))
      }))
      .map((e) => (e.options.length === 1 ? e.options[0] : e));
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
